<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default{
  mounted(){
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    let _this = this;
    setTimeout(function() {
      if (isMobile) {
        if(_this.$route.name=='login'){
          window.location.href = 'http://xwt.softykt.com/Mdist/login'
        }
        if(_this.$route.name=='superlogin'){
          window.location.href = 'http://xwt.softykt.com/Mdist/superlogin'
        }
      } else {
        
      }
    }, 500);
  }
}
</script>
<style lang="less">
.el-pagination__jump{
  display: none !important;
}
/deep/.el-dialog__headerbtn{
  top: 0;
}
</style>
